import { Typography } from 'antd';

const { Text } = Typography;

interface Props {
  showNote?: boolean;
}

export default function GuestCustomerBadge({ showNote = false }: Props) {
  return (
    <span style={{ display: 'inline-flex', flexDirection: 'column', gap: 2 }}>
      <span
        style={{
          display: 'inline-block',
          background: 'var(--bl-muted-soft, #f0f0f0)',
          color: 'var(--bl-text-muted, #6b7280)',
          fontSize: 11,
          fontWeight: 600,
          borderRadius: 999,
          padding: '2px 8px',
          lineHeight: '18px',
        }}
      >
        Mehmon
      </span>
      {showNote && (
        <Text
          type="secondary"
          style={{ fontSize: 11, display: 'block', marginTop: 2 }}
        >
          Telegram orqali ro&apos;yxatdan o&apos;tmagan
        </Text>
      )}
    </span>
  );
}
